"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Skeleton_1 = __importDefault(require("@mui/material/Skeleton"));
const ChangeLog_1 = __importDefault(require("@/components/ChangeLog"));
function ComponentsChangeLogView({ changeLogItems, loadMoreRef, hasDataEnded, isLoading, }) {
    return isLoading && changeLogItems.length === 0 ? (react_1.default.createElement(Skeleton_1.default, { variant: "rectangular", sx: { width: "100%", height: "530px" } })) : (react_1.default.createElement(ChangeLog_1.default, { changelogItems: changeLogItems, hasDataEnded: hasDataEnded, loadMoreRef: loadMoreRef }));
}
exports.default = ComponentsChangeLogView;
